export default {"src":"/_next/static/media/ollie-logo-plum.c86dfacf.svg","height":900,"width":1857,"blurWidth":0,"blurHeight":0};